import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useContext } from 'react';

import { translate } from '@/ui/i18n';

import { ImpactQuestionContext } from './ImpactQuestionContext';

export function QuizPanelHideCompletedCheckBox() {
  const { hideCompleted, setHideCompleted } = useContext(ImpactQuestionContext);
  return (
    <FormControlLabel
      sx={{ marginTop: 2 }}
      label={<Typography>{translate('Quiz.hide-completed')}</Typography>}
      control={
        <Checkbox
          checked={hideCompleted}
          onChange={() => {
            if (setHideCompleted) setHideCompleted(!hideCompleted);
          }}
        />
      }
    />
  );
}
